// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Elementos
    const $section = $('#fbc');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['fbc-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Elementos
    const $section = $('#fbc');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['fbc-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--fbc-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Elementos
    const $section = $('#fbc');
    const $secTitle = $('.fbc-titulo');
    const $secText = $('.fbc-texto');

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['titulo'];
      $secTitle.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['fbc-tit-color'];
      $section[0].style.setProperty('--fbc-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['texto'];
      $secText.html(fmtTxt(value));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['fbc-txt-color'];
      $section[0].style.setProperty('--fbc-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      $section[0].style.setProperty('--txt-alt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

    // Altera a cor de fundo do texto
    function changeTxtBgColor() {
      const color = confTheme[ref]['txt-bg-color'];
      $section[0].style.setProperty('--txt-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
  }
})();

// ------------------------------------
// BOTÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Elementos
    const $secButton = $('.fbc-botao');

    // Oculta/Exibe o botão
    function changeBtnShow() {
      const value = confTheme[ref2]['btn-show'];
      value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

    // Altera a classe do botão
    function changeBtnClass() {
      const value = confTheme[ref2]['btn-class'];
      const styleClass = confTheme['general'][value + '-style'];
      const AnimationClass = confTheme['general'][value + '-animation'];
      $secButton
        .find('.btn')
        .removeClass(btnClassesRem)
        .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnText() {
      const value = confTheme[ref2]['btn-text'];
      $secButton.find('.btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);

    // Oculta/Exibe o selo
    function changeSealShow() {
      const value = confTheme[ref2]['seal-show'];
      value == '1'
        ? $secButton.find('.btn-selos').removeClass('d-none')
        : $secButton.find('.btn-selos').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('#fbc .section-divider').addClass('d-none');
      if (value) {
        $('#fbc .section-divider.' + value).removeClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      $('#fbc')[0].style.setProperty('--divisor-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();

// ------------------------------------
// LISTA
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'fbc-var';
    const ref2 = 'fbc';
    const refEvtPrefix = 'lp-evt-fbc-';

    // Elementos
    const $list = $('.fbc-list');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['lista'];
      const total = lista.length;
      if ($list.length > 0) {
        $list.html('');
        for (let i = 0; i < total; i++) {
          if (!lista[i].resposta_de) {
            const listResp = [];
            for (let j = 0; j < total; j++) {
              if (lista[j].resposta_de == lista[i].id) {
                listResp.push(lista[j]);
              }
            }

            // Lista respostas
            let $listResp = '';
            if (listResp.length > 0) {
              $listResp = '<ul class="fbc-replies">';
              for (let x = 0; x < listResp.length; x++) {
                const $likesResp = listResp[x].likes > 0 ? `<div class="fbc-likes">${listResp[x].likes}</div>` : '';
                $listResp += `
                <li class="fbc-item ${hasRepliesClass}">
                  <figure class="img img-circle fbc-item-img">
                    <img src="${listResp[x].img}" alt="${listResp[x].alt}">
                  </figure>
                  <div class="fbc-infos">
                    <div class="fbc-content">
                      <div class="fbc-title"><span>${listResp[x].titulo}</span></div>
                      <div class="fbc-text">${fmtTxt(listResp[x].texto, true)}</div>
                      ${$likesResp}
                    </div>
                    <div class="fbc-action">
                      <div class="fbc-action-item fbc-link">Curtir</div>
                      <div class="fbc-action-item fbc-link">Responder</div>
                      <div class="fbc-action-item fbc-date">${listResp[x].data}</div>
                    </div>
                  </div>
                </li>`;
              }
              $listResp += '</ul>';
            }

            const hasRepliesClass = listResp.length > 0 ? 'has-replies' : '';
            const $likes = lista[i].likes > 0 ? `<div class="fbc-likes">${lista[i].likes}</div>` : '';
            const item = `
            <li class="fbc-item ${hasRepliesClass}">
              <figure class="img img-circle fbc-item-img">
                <img src="${lista[i].img}" alt="${lista[i].alt}">
              </figure>
              <div class="fbc-infos">
                <div class="fbc-content">
                  <div class="fbc-title"><span>${lista[i].titulo}</span></div>
                  <div class="fbc-text">${fmtTxt(lista[i].texto, true)}</div>
                  ${$likes}
                </div>
                <div class="fbc-action">
                  <div class="fbc-action-item fbc-link">Curtir</div>
                  <div class="fbc-action-item fbc-link">Responder</div>
                  <div class="fbc-action-item fbc-date">${lista[i].data}</div>
                </div>
                ${$listResp}
              </div>
            </li>`;
            $list.append(item);
          }
        }
        $('.fbc-card-tit').text(total + ' Comentários');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);
  }
})();
